/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import { Form, Formik, FormikHelpers } from 'formik'
import { Base64 } from 'js-base64'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Switch from 'react-switch'

import CircularProgress from '@mui/material/CircularProgress'
import { FiCheckCircle, FiClock, FiEdit3 } from 'react-icons/fi'

import usePersistedState from '../../hooks/usePersistedState'

import Button from '../../components/Button'
import Header from '../../components/Header'

import ModalBox from '../../components/Modal'
import api from '../../services/api'
import {
  ConfigData,
  ErroProps,
  Participant,
  ServiceTimeData,
  UserData,
} from '../../utils/interfaces'
import {
  GrauParentescoList,
  NaturezaJuridicaList,
  ResponsavelTempoList,
  TipoVinculoList,
} from '../../utils/listasFixas'
import { Cpf, RgMask } from '../../utils/masks'

type ApiDocumento = {
  codDoc: string
  nomeDoc: string
  url: string
}

type ConfirmOwnershipFormValues = {
  check: boolean
}

const Resume: React.FC = () => {
  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )

  const [configData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )

  const [participants] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )

  const [servicesTime] = usePersistedState<ServiceTimeData[]>(
    'servicestimeGroup',
    [],
  )

  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )

  const [authorizeFlag, setAuthorizeFlag] = useState(false)

  const [aguarde, setAguarde] = useState(false)
  const [reSend, setReSend] = useState(true)
  const [timer, setTimer] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [warningText, setWarningText] = useState('')

  const [attachedFiles, setAttachedFiles] = useState<
    Array<{
      docCode: string
      docLabel: string
      name: string
      type: string
      url: string
    }>
  >([])

  useEffect(() => {
    const raw = localStorage.getItem('@Iprejun:documentsAttached')
    if (raw) {
      try {
        const files = JSON.parse(raw)
        setAttachedFiles(files)
      } catch (err) {
        console.error('Erro ao carregar documentos', err)
      }
    }
  }, [])

  function handleCloseModal(): void {
    setIsModalOpen(false)
  }

  const navigate = useNavigate()

  const toggleAuthorizeFlag = useCallback(() => {
    setAuthorizeFlag(!authorizeFlag)
  }, [authorizeFlag, setAuthorizeFlag])

  const handleSubmit = useCallback(
    async (
      data: ConfirmOwnershipFormValues,
      helpers: FormikHelpers<ConfirmOwnershipFormValues>,
    ) => {
      try {
        setAguarde(true)

        const normalizeUrl = (url?: string) => (url ?? '').replace('blob:', '')

        const docUniqKey = (codDoc: string, nomeDoc: string, url: string) =>
          `${codDoc}__${nomeDoc}__${url}`

        const documentosFromBeneficiarios: ApiDocumento[] = (participants ?? [])
          .reduce<
            Array<
              NonNullable<(typeof participants)[number]['attachedDocs']>[number]
            >
          >((acc, p) => {
            const docs = p.attachedDocs ?? []
            return acc.concat(docs)
          }, [])
          .map((d) => ({
            codDoc: d.docCode,
            nomeDoc: d.name,
            url: normalizeUrl(d.url),
          }))

        const documentosFromTempos: ApiDocumento[] = (servicesTime ?? [])
          .reduce<
            Array<
              NonNullable<(typeof servicesTime)[number]['attachedDocs']>[number]
            >
          >((acc, t) => {
            const docs = t.attachedDocs ?? []
            return acc.concat(docs)
          }, [])
          .map((d) => ({
            codDoc: d.docCode,
            nomeDoc: d.name,
            url: normalizeUrl(d.url),
          }))

        const documentosFromTelaFinal: ApiDocumento[] = (
          attachedFiles ?? []
        ).map((f) => ({
          codDoc: f.docCode,
          nomeDoc: f.name,
          url: normalizeUrl(f.url),
        }))

        const documentos: ApiDocumento[] = (() => {
          const all = [
            ...documentosFromTelaFinal,
            ...documentosFromBeneficiarios,
            ...documentosFromTempos,
          ]

          const map = new Map<string, ApiDocumento>()
          all.forEach((doc) => {
            const key = docUniqKey(doc.codDoc, doc.nomeDoc, doc.url)
            map.set(key, doc)
          })

          return Array.from(map.values())
        })()

        const payloadObj = {
          token: configData.token || 'undefined',
          cliente: configData.codCliente,
          versao: configData.tipo,
          nome: (userData?.name ?? '').toLowerCase(),
          cpf: (userData?.cpf ?? '').replace(/\./g, '').replace('-', ''),
          nascimento: userData?.birthdate ?? '',
          email: userData?.email ?? '',
          telefone: `55${(userData?.phone ?? '')
            .replace('(', '')
            .replace(') ', '')
            .replace('-', '')}`,
          rg: userData?.rg ?? '',
          estadoCivil: userData?.maritalState ?? '',
          genero: userData?.gender ?? '',
          lugarNascimento: userData?.birthPlace ?? '',
          possuiDeficiencia: userData?.deficiency ?? '',
          dcrDeficiencia: userData?.deficiencyDcr ?? '',
          filiacao1: userData?.parental1 ?? '',
          filiacao2: userData?.parental2 ?? '',
          dependentes: (participants ?? []).map((p) => ({
            nome: p.name ?? '',
            nascimento: p.birthdate ?? '',
            cpf: (p.cpf ?? '').replace(/\./g, '').replace('-', ''),
            rg: p.rg ?? '',
            possuiDeficiencia: p.hasDeficiency ?? '',
            dcrDeficiencia: p.deficiencyDcr ?? '',
            grauParentesco: p.grauParentesco ?? '',
          })),
          temposServico: (servicesTime ?? []).map((s) => ({
            dcrOrganizacao: s.organizationDcr ?? '',
            responsavelTempo: s.timeResponsible ?? '',
            magisterio: s.teaching ?? '',
            saude: s.health ?? '',
            tipoVinculo: s.typeLink ?? '',
            naturezaJuridica: s.legalNature ?? '',
            dataAdmissao: s.startDate ?? '',
            dataDemissao: s.endDate ?? '',
            dcrCargo: s.positionDcr ?? '',
          })),
          documentos,
        }

        const json = JSON.stringify(payloadObj)

        const parametros = Base64.encode(json)
        const parametrosFinal = Base64.encode(parametros)

        await api.post(
          `wsAdesaoIprejun.rule?sys=ADZ`, // &Entrada=${parametrosFinal}
          json,
          {
            headers: {
              'Content-Type': 'text/plain',
            },
          },
        )

        navigate('/end')
      } catch (err: unknown) {
        console.error('Erro no submit Resume:', err)

        setAguarde(false)

        const message = err instanceof Error ? err.message : 'Erro desconhecido'

        if (message === 'Request failed with status code 401') {
          alert('Tempo de sessão expirado')
          navigate('/')
        } else if (message === 'Request failed with status code 406') {
          setWarningText(
            'Cadastro não autorizado. Verifique se você já possui cadastro no plano.',
          )
          setIsModalOpen(true)
          setReSend(false)
          setTimer(20)
        } else if (message === 'Network Error') {
          setErroProps({
            title: message,
            description: 'Falha na conexão com o servidor',
          })
          navigate('/erro')
        } else if (message === 'Request failed with status code 500') {
          setErroProps({
            title: 'Erro interno no servidor',
            description: message,
          })
          navigate('/erro')
        } else if (message === 'Request failed with status code 408') {
          alert('Tempo de sessão expirado')
          navigate('/')
        } else {
          setWarningText('Ops, algo deu errado. Tente novamente mais tarde.')
          setIsModalOpen(true)
          setReSend(false)
          setTimer(20)
        }
      } finally {
        helpers.setSubmitting(false)
      }
    },
    [
      attachedFiles,
      configData,
      navigate,
      participants,
      servicesTime,
      setErroProps,
      userData,
    ],
  )

  useEffect(() => {
    const countTimer = (): void => {
      if (timer > 1) setTimer(timer - 1)
      else if (timer === 1) {
        setTimer(timer - 1)
        setReSend(true)
      }
    }
    const interval = setInterval(countTimer, 1000)
    return () => clearInterval(interval)
  }, [timer])

  return (
    <>
      <Header />
      <div className="mx-auto mb-[15px] flex max-w-[600px] flex-col items-center px-[5px] max-[766px]:max-w-[550px]">
        <div className="w-full rounded-[8px] bg-white p-[30px_25px] shadow-[0px_2px_4px_rgba(0,0,0,0.05),0px_6px_12px_rgba(61,69,67,0.05)] mb-[10px] mx-[5px] max-[766px]:p-[20px_15px]">
          <strong className="mb-7 flex justify-center text-center text-[18px] text-[#0071ba]">
            Resumo dos Dados
          </strong>
          {/* Informações Pessoais */}
          <div className="mb-6 border-b border-[rgba(132,147,244,0.6)] pb-6">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-[16px] font-semibold text-[#0071ba]">
                Informações Pessoais
              </h3>

              <button
                type="button"
                className="inline-flex items-center font-semibold border gap-2 rounded-full px-3 py-1 hover:border-[#0071ba] hover:text-[#0071ba]"
                onClick={() => navigate('/personal-info')}
              >
                <FiEdit3 className="mr-2" />
                Editar dados
              </button>
            </div>
            <div className="">
              <p>
                Nome: <strong>{userData.name || 'Não informado'}</strong>
              </p>
              <p>
                CPF: <strong>{Cpf(userData.cpf) || 'Não informado'}</strong>
              </p>
              <p>
                Data de Nascimento:{' '}
                <strong>
                  {userData.birthdate.split('-').reverse().join('/') ||
                    'Não informado'}
                </strong>
              </p>
              <p>
                Email: <strong>{userData.email || 'Não informado'}</strong>
              </p>
              <p>
                Telefone: <strong>{userData.phone || 'Não informado'}</strong>
              </p>
              <p>
                RG: <strong>{RgMask(userData.rg) || 'Não informado'}</strong>
              </p>
              <p>
                Nome da mãe:{' '}
                <strong>{userData.parental1 || 'Não informado'}</strong>
              </p>
              <p>
                Nome do pai:{' '}
                <strong>{userData.parental2 || 'Não informado'}</strong>
              </p>
              <p>
                Local de Nascimento:{' '}
                <strong>{userData.birthPlace || 'Não informado'}</strong>
              </p>
              <p>
                Possui Deficiência:{' '}
                <strong>
                  {userData.deficiency === 'S'
                    ? 'Sim'
                    : userData.deficiency === 'N'
                      ? 'Não'
                      : 'Não informado'}
                </strong>
              </p>
              {userData.deficiency === 'S' && (
                <p>
                  Descrição da Deficiência:{' '}
                  <strong>{userData.deficiencyDcr || 'Não informado'}</strong>
                </p>
              )}
            </div>
          </div>

          {/* Beneficiários */}
          <div className="mb-6 border-b border-[rgba(132,147,244,0.6)] pb-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-[16px] font-semibold text-[#0071ba]">
                Dependentes
              </h3>
              <button
                type="button"
                className="inline-flex items-center font-semibold border gap-2 rounded-full px-3 py-1 hover:border-[#0071ba] hover:text-[#0071ba]"
                onClick={() => navigate('/beneficiary')}
              >
                <FiEdit3 className="mr-2" />
                Editar dados
              </button>
            </div>
            {participants.length > 0 ? (
              <div className="space-y-2">
                {participants.map((participant, index) => (
                  <div
                    key={index}
                    className={`${index === participants.length - 1 ? '' : 'border-b'} pb-2`}
                  >
                    <p>
                      Nome: <strong>{participant.name}</strong>
                    </p>
                    <p>
                      CPF: <strong>{Cpf(participant.cpf)}</strong>
                    </p>
                    <p>
                      Data de Nascimento:{' '}
                      <strong>
                        {participant.birthdate.split('-').reverse().join('/') ||
                          'Não informado'}
                      </strong>
                    </p>
                    <p>
                      RG:{' '}
                      <strong>
                        {RgMask(participant.rg) || 'Não informado'}
                      </strong>
                    </p>
                    <p>
                      Grau de Parentesco:{' '}
                      <strong>
                        {
                          GrauParentescoList.filter(
                            (v) =>
                              String(v.value) ===
                              String(participant.grauParentesco),
                          )[0]?.label
                        }
                      </strong>
                    </p>
                    <p>
                      Possui Deficiência:{' '}
                      <strong>
                        {participant.hasDeficiency === 'S'
                          ? 'Sim'
                          : participant.hasDeficiency === 'N'
                            ? 'Não'
                            : 'Não informado'}
                      </strong>
                    </p>
                    {participant.hasDeficiency === 'S' && (
                      <p>
                        Descrição da Deficiência:{' '}
                        <strong>
                          {participant.deficiencyDcr || 'Não informado'}
                        </strong>
                      </p>
                    )}
                    <div className="my-[6px]">
                      <label>Documentos anexados: </label>
                      {(participant?.attachedDocs?.length ?? 0) > 0 ? (
                        <div className="px-2">
                          {(participant?.attachedDocs ?? []).map((doc) => (
                            <div
                              key={doc.id}
                              className="flex items-center justify-between gap-2 py-1"
                            >
                              <strong
                                className="truncate"
                                title={`${doc.docLabel} | ${doc.name}`}
                              >
                                {doc.docLabel} | {doc.name}
                              </strong>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <strong className="text-red-600">Não anexado</strong>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>Nenhum dependente cadastrado.</p>
            )}
          </div>

          {/* Tempo de Serviço */}
          <div className="mb-6 border-b border-[rgba(132,147,244,0.6)] pb-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-[16px] font-semibold text-[#0071ba]">
                Tempo de Contribuição
              </h3>
              <button
                type="button"
                className="inline-flex items-center font-semibold border gap-2 rounded-full px-3 py-1 hover:border-[#0071ba] hover:text-[#0071ba]"
                onClick={() => navigate('/service-time')}
              >
                <FiEdit3 className="mr-2" />
                Editar dados
              </button>
            </div>
            {servicesTime.length > 0 ? (
              <div className="space-y-2">
                {servicesTime.map((service, index) => (
                  <div
                    key={index}
                    className={`${index === servicesTime.length - 1 ? '' : 'border-b'} pb-2`}
                  >
                    <p>
                      Descrição da organização:{' '}
                      <strong>{service.organizationDcr}</strong>
                    </p>
                    <p>
                      Responsável pelo tempo:{' '}
                      <strong>
                        {
                          ResponsavelTempoList.find(
                            (v) => v.value === service.timeResponsible,
                          )?.label
                        }
                      </strong>
                    </p>
                    <p>
                      Professor de Educação Básica:{' '}
                      <strong>
                        {service.teaching === 'S' ? 'Sim' : 'Não'}
                      </strong>
                    </p>
                    <p>
                      Área da saúde:{' '}
                      <strong>{service.health === 'S' ? 'Sim' : 'Não'}</strong>
                    </p>
                    <p>
                      Vínculo:{' '}
                      <strong>
                        {' '}
                        {
                          TipoVinculoList.find(
                            (v) => v.value === service.typeLink,
                          )?.label
                        }
                      </strong>
                    </p>
                    <p>
                      Natureza jurídica:{' '}
                      <strong>
                        {
                          NaturezaJuridicaList.find(
                            (v) => v.value === service.legalNature,
                          )?.label
                        }
                      </strong>
                    </p>
                    <p>
                      Admissão / Posse:{' '}
                      <strong>
                        {service.startDate
                          ? service.startDate.split('-').reverse().join('/')
                          : ''}
                      </strong>
                    </p>
                    <p>
                      Demissão / Exoneração:{' '}
                      <strong>
                        {service.endDate
                          ? service.endDate.split('-').reverse().join('/')
                          : ''}
                      </strong>
                    </p>

                    <div className="my-[6px]">
                      <label>Documenos anexados: </label>
                      {(service.attachedDocs?.length ?? 0) > 0 ? (
                        <div className="px-2">
                          {(service.attachedDocs ?? []).map((doc) => (
                            <div
                              key={doc.id}
                              className="flex items-center justify-between gap-2 py-1"
                            >
                              <strong
                                className="truncate"
                                title={`${doc.docLabel} | ${doc.name}`}
                              >
                                {doc.docLabel} | {doc.name}
                              </strong>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <strong className="text-red-600">Não anexado</strong>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>Nenhum tempo de contribuição cadastrado.</p>
            )}
          </div>

          {/* Documentos */}
          <div className="mb-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-[16px] font-semibold text-[#0071ba]">
                Documentos
              </h3>
              <button
                type="button"
                className="inline-flex items-center font-semibold border gap-2 rounded-full px-3 py-1 hover:border-[#0071ba] hover:text-[#0071ba]"
                onClick={() => navigate('/supporting-documents')}
              >
                <FiEdit3 className="mr-2" />
                Editar dados
              </button>
            </div>
            {attachedFiles.length > 0 ? (
              <div className="space-y-2">
                {attachedFiles.map((file, index) => (
                  <div
                    key={index}
                    className={`${index === attachedFiles.length - 1 ? '' : 'border-b'} pb-2`}
                  >
                    <p>
                      Documento: <strong>{file.docLabel}</strong>
                    </p>
                    <p>
                      Arquivo: <strong>{file.name}</strong>
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p>Nenhum documento anexado.</p>
            )}
          </div>
        </div>

        {/* Bloco de Confirmação */}
        <Formik initialValues={{ check: false }} onSubmit={handleSubmit}>
          {({ submitForm }) => (
            <Form className="w-full">
              <div className="w-full rounded-[8px] bg-white p-[30px_25px] shadow-[0px_2px_4px_rgba(0,0,0,0.05),0px_6px_12px_rgba(61,69,67,0.05)] mb-[10px] mx-[5px] max-[766px]:p-[20px_15px]">
                <strong className="mb-6 flex justify-center text-center text-[18px] text-[#0071ba]">
                  Da responsabilidade do usuário:
                </strong>

                <div className="mt-[25px] flex items-top gap-2 justify-start text-left ">
                  <Switch
                    onChange={toggleAuthorizeFlag}
                    checked={authorizeFlag}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    height={20}
                    width={40}
                    handleDiameter={16}
                    offColor="#FAB2B3"
                    offHandleColor="#fff"
                    onHandleColor="#fff"
                    onColor="#31D19E"
                    className="mt-1"
                    name="check"
                  />
                  <p className="text-sm">
                    Eu <b>{userData.name}</b>, inscrito no CPF{' '}
                    <b>{Cpf(userData.cpf)}</b>, declaro estar de inteira
                    responsabilidade pelas informações realizadas, estando
                    ciente de que a falsidade nas informações prestadas
                    configura crime previsto no Código Penal Brasileiro,
                    passível de apuração na forma da Lei, bem como poderá ser
                    enquadrada como Litigância de Má Fé.
                  </p>
                </div>
              </div>
              <div className="flex w-full justify-center">
                <Button
                  type="button"
                  color="blue"
                  disabled={!authorizeFlag || !reSend || aguarde}
                  onClick={submitForm}
                  className="min-w-fit gap-3 px-10"
                >
                  {!aguarde ? (
                    !reSend ? (
                      <>
                        <FiClock size={24} />
                        Tente novamente em {timer < 10
                          ? `0${timer}`
                          : timer}{' '}
                        segundos
                      </>
                    ) : (
                      <>
                        Confirmar cadastro
                        <FiCheckCircle size={24} />
                      </>
                    )
                  ) : (
                    <>
                      <CircularProgress color="inherit" size={24} /> Aguarde
                    </>
                  )}
                </Button>
              </div>
            </Form>
          )}
        </Formik>

        <button
          type="button"
          onClick={() => navigate('/supporting-documents')}
          className="mb-[15px] flex flex-col items-center justify-center border-0 border-b border-transparent bg-transparent text-[#333] hover:border-[#333] focus:border-[#333]"
        >
          &lt; Anterior
        </button>

        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          <p>{warningText}</p>
        </ModalBox>
      </div>
    </>
  )
}

export default Resume
